var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAlign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.406,
    height: 15.5,
    viewBox: "0 0 36.406 15.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1186",
    "data-name": "Group 1186",
    transform: "translate(-7 -363)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Align",
    transform: "translate(16147.75 23689.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.02,15.4H2.98C.97,15.4,0,14.47,0,12.55V.75A.755.755,0,0,1,.75,0,.755.755,0,0,1,1.5.75v11.8c0,1.01.21,1.35,1.48,1.35H4.02c1.27,0,1.48-.34,1.48-1.35V.75A.75.75,0,0,1,7,.75v11.8C7,14.47,6.03,15.4,4.02,15.4Z",
    transform: "translate(-16128.99 -23326.65)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M4.02,10.4H2.98C.97,10.4,0,9.47,0,7.55V.75A.755.755,0,0,1,.75,0,.755.755,0,0,1,1.5.75v6.8c0,1.01.21,1.35,1.48,1.35H4.02c1.27,0,1.48-.34,1.48-1.35V.75A.75.75,0,0,1,7,.75v6.8C7,9.47,6.03,10.4,4.02,10.4Z",
    transform: "translate(-16137.49 -23326.65)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M20.75,1.5H.75A.75.75,0,0,1,.75,0h20a.75.75,0,0,1,0,1.5Z",
    transform: "translate(-16140.75 -23326.75)",
    fill: "#061133"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M3.688,8.231.3,4.843a1.032,1.032,0,0,1,0-1.455L3.688,0",
    transform: "translate(34.115 372.188) rotate(-90)",
    fill: "none",
    stroke: "#061133",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlign);
export default __webpack_public_path__ + "static/media/Icon-align.6754e07838026f1133e3a30e18336ec9.svg";
export { ForwardRef as ReactComponent };